export default __webpack_public_path__ + "static/media/woman-with-laptop.32c9bc50.svg";